var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "house-item",
      on: {
        click: function ($event) {
          return _vm.triggleEvent("detail")
        },
      },
    },
    [
      !_vm.pic
        ? _c("img", {
            staticClass: "item-preview",
            attrs: { src: require("../images/preview-defalt-new.png") },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.pic
        ? _c("img", { staticClass: "item-preview", attrs: { src: _vm.pic } })
        : _vm._e(),
      _vm._v(" "),
      _vm.house.is_zd_fang && _vm.house.is_zd_fang == "yes"
        ? _c("img", {
            staticClass: "zd-house",
            attrs: { src: require("../images/icon-zd-house.png") },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.house.vr_addr != ""
        ? _c("img", {
            staticClass: "house-vr-img",
            attrs: { src: require("../images/vr.png") },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "house-infohouse-vr-img" }, [
        _c("div", { staticClass: "house-info-title" }, [
          _vm._v(
            _vm._s(
              _vm.type == 1 ? _vm.house.loupan : _vm.house.xiaoqumingcheng_id
            )
          ),
        ]),
        _vm._v(" "),
        _vm.type == 2 || _vm.type == 3
          ? _c("div", { staticClass: "other" }, [
              _vm._v(
                _vm._s(_vm.house.shi) +
                  "室" +
                  _vm._s(_vm.house.ting) +
                  "厅/" +
                  _vm._s(_vm.house.taoneimianji) +
                  "m²/" +
                  _vm._s(_vm.house.chaoxiang_id) +
                  "/" +
                  _vm._s(_vm.house.xiaoqumingcheng_id)
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.type == 2
          ? _c("div", { staticClass: "money" }, [
              _c("span", { staticClass: "amout" }, [
                _vm._v(_vm._s(_vm.house.shoujia) + "万"),
              ]),
              _vm._v(
                _vm._s(
                  Math.floor(
                    ((_vm.house.shoujia * 10000) / _vm.house.taoneimianji) * 100
                  ) / 100
                ) + "元/平"
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.type == 3
          ? _c("div", { staticClass: "money" }, [
              _c("span", { staticClass: "amout" }, [
                _vm._v(
                  _vm._s(_vm.house.shoujia) + _vm._s(_vm.house.zujindanwei)
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.type == 1
          ? _c("div", { staticClass: "location" }, [
              _vm._v(_vm._s(_vm.house.xiangxidizhi || "暂无")),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.house.biaoqian && _vm.house.biaoqian.length > 0
          ? _c(
              "div",
              { staticClass: "house-info-tags" },
              _vm._l(_vm.house.biaoqian, function (tag) {
                return _c("span", { staticClass: "tag" }, [
                  _vm._v(_vm._s(tag.name)),
                ])
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.type == 1
          ? _c("div", { staticClass: "house-price" }, [
              _c("span", { staticClass: "junjia" }, [
                _vm._v(_vm._s(_vm.house.junjia) + "元/平"),
              ]),
              _vm._v(" 建面 " + _vm._s(_vm.house.mianji || "暂无") + "m²"),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "house-gn-list" }, [
          _vm.house.is_have_ys && _vm.house.is_have_ys == "yes"
            ? _c("div", { staticClass: "house-key" }, [_vm._v("钥匙房")])
            : _vm._e(),
          _vm._v(" "),
          _vm.house.vr_addr != ""
            ? _c("img", {
                staticClass: "house-vr",
                attrs: { src: require("../images/icon-vr.png") },
              })
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }